/**
 * TABLA NUMÉRICA - Sistema de Ayuda Completo con Validaciones Mejoradas
 * Pantalla dedicada para resolver operaciones con tabla del 100
 */

// ===== ESTADO GLOBAL =====
let tableState = {
    num1: 0,
    num2: 0,
    operation: 'suma', // 'suma' o 'resta'
    startNumber: 0,
    targetNumber: 0,
    currentStep: 1,
    lastClickedNumber: null,
    helpVisible: false,
    helpWasUsed: false,   // true si el alumno usó la ayuda guiada
    clickedCells: [],
    startNumberClicked: false, // Validación paso 1
    rowsClicked: [], // Validación paso 2
    savedUserSelection: null
};

// ===== FUNCIONES DE NAVEGACIÓN =====

/**
 * Abrir pantalla de tabla numérica desde Step 5
 */
function openNumericTableScreen(num1, num2, operation) {
    // Guardar datos en el estado
    tableState.num1 = num1;
    tableState.num2 = num2;
    tableState.operation = operation;

    // El número de inicio depende de la operación (en resta siempre se parte del minuendo num1)
    if (operation === 'suma') {
        tableState.startNumber = Math.max(num1, num2);
        tableState.targetNumber = num1 + num2;
    } else {
        tableState.startNumber = num1;
        tableState.targetNumber = num1 - num2;
    }

    // Resetear estado
    tableState.currentStep = 1;
    tableState.lastClickedNumber = null;
    tableState.helpVisible = false;
    tableState.helpWasUsed = false;
    tableState.clickedCells = [];
    tableState.startNumberClicked = false;
    tableState.rowsClicked = [];

    // Generar tabla y actualizar UI
    generateNumericTable();
    updateOperationDisplay();
    updateHelpContent();
    resetHelpPanel();

    // Ocultar pantalla de problemas
    const problemScreen = document.getElementById('problemScreen');
    problemScreen.classList.remove('active');
    problemScreen.classList.add('hidden');

    // Mostrar pantalla de tabla numérica
    const tableScreen = document.getElementById('numericTableScreen');
    tableScreen.classList.remove('hidden');
    tableScreen.classList.add('active');

    console.log('📊 Pantalla de tabla numérica abierta');
}

/**
 * Cerrar pantalla y volver a Step 5
 */
function closeNumericTableScreen(returnResult = false) {
    if (returnResult && tableState.lastClickedNumber !== null) {
        // Devolver resultado al Step 5
        const calcNumberDisplay = document.getElementById('selectedCalcNumber');
        if (calcNumberDisplay) {
            calcNumberDisplay.textContent = tableState.lastClickedNumber;
        }

        // Marcar tabla como completada
        window.tableCalculationComplete = true;
    }

    // Ocultar pantalla de tabla numérica
    const tableScreen = document.getElementById('numericTableScreen');
    tableScreen.classList.remove('active');
    tableScreen.classList.add('hidden');

    // Mostrar pantalla de problemas
    const problemScreen = document.getElementById('problemScreen');
    problemScreen.classList.remove('hidden');
    problemScreen.classList.add('active');

    console.log('📊 Volviendo a Step 5');
}

// ===== GENERACIÓN DE TABLA =====

/**
 * Generar tabla del 100 con codificación de colores EN LOS DÍGITOS
 */
function generateNumericTable() {
    const table = document.getElementById('numericTable100');
    table.innerHTML = '';

    for (let row = 0; row < 10; row++) {
        const tr = document.createElement('tr');

        for (let col = 0; col < 10; col++) {
            const number = row * 10 + col + 1;
            const td = document.createElement('td');
            td.dataset.number = number;

            // COLOREAR DÍGITOS DEL NÚMERO (decenas rojas, unidades azules)
            const numStr = number.toString();
            if (numStr.length === 1) {
                // Solo unidad (azul)
                td.innerHTML = `<span style="color: #1e40af; font-weight: 800;">${numStr}</span>`;
            } else {
                // Dividir en decenas (rojo) y unidad (azul)
                const tens = numStr.substring(0, numStr.length - 1);
                const unit = numStr.substring(numStr.length - 1);
                td.innerHTML = `<span style="color: #991b1b; font-weight: 800;">${tens}</span><span style="color: #1e40af; font-weight: 800;">${unit}</span>`;
            }

            // Aplicar código de color al fondo (mantener para compatibilidad)
            if (number % 10 === 0) {
                td.classList.add('tens-color'); // Fondo para decenas
            } else {
                td.classList.add('unit-color'); // Fondo para unidades
            }

            // NO marcar número inicial - el alumno debe encontrarlo (Paso 1)
            // NO marcar número objetivo - no mostrar la solución

            // Event listener para clicks
            td.addEventListener('click', () => handleTableCellClick(number, td));

            tr.appendChild(td);
        }

        table.appendChild(tr);
    }
}

/**
 * Mostrar mensaje de error sobre la tabla con pista de razonamiento
 */
function showTableError(message, hint) {
    // Buscar o crear overlay de error
    let errorOverlay = document.querySelector('.table-error-overlay');

    if (!errorOverlay) {
        errorOverlay = document.createElement('div');
        errorOverlay.className = 'table-error-overlay';
        document.querySelector('.table-section').appendChild(errorOverlay);
    }

    errorOverlay.innerHTML = `
        <div class="error-message">
            <div class="error-icon">❌</div>
            <div class="error-text">${message}</div>
            ${hint ? `<div class="error-hint">💡 ${hint}</div>` : ''}
        </div>
    `;

    errorOverlay.classList.add('visible');

    // Reproducir mensaje de error por audio
    if (typeof speak === 'function') {
        speak(message + (hint ? ' ' + hint : ''), window.currentLanguage);
    }

    // Auto-ocultar después de 4 segundos
    setTimeout(() => {
        errorOverlay.classList.remove('visible');
    }, 4000);
}

function handleTableCellClick(number, cell) {
    // TOGGLE: Si la celda ya está seleccionada, deseleccionarla
    if (cell.classList.contains('clicked') || cell.classList.contains('start-number')) {
        cell.classList.remove('clicked', 'selected-help', 'start-number');

        // Eliminar indicaciones de operación (+1, -1, etc) dentro de esta celda
        const indicators = cell.querySelectorAll('.operation-indicator');
        indicators.forEach(i => i.remove());

        // Quitar de la lista de clickeados
        tableState.clickedCells = tableState.clickedCells.filter(n => n !== number);

        // Resetear validación de paso 1 si era el número inicial
        if (number === tableState.startNumber) {
            tableState.startNumberClicked = false;
        }

        // Reajustar "último número" al anterior que quede en la lista
        if (tableState.lastClickedNumber === number) {
            if (tableState.clickedCells.length > 0) {
                const prevNum = tableState.clickedCells[tableState.clickedCells.length - 1];
                tableState.lastClickedNumber = prevNum;
                lastClickedCellForIndicators = document.querySelector(`.numeric-table-100 td[data-number="${prevNum}"]`);
                updateQuickAnswerBox(prevNum);
            } else {
                tableState.lastClickedNumber = null;
                lastClickedCellForIndicators = null;
                updateQuickAnswerBox(null);
            }
        }
        return;
    }

    // Mostrar indicadores de operación si hay un click previo
    if (lastClickedCellForIndicators && tableState.lastClickedNumber) {
        showOperationIndicator(
            tableState.lastClickedNumber,
            number,
            lastClickedCellForIndicators,
            cell
        );
    }

    // Actualizar último número y celda clickeados
    tableState.lastClickedNumber = number;
    lastClickedCellForIndicators = cell;

    // Actualizar recuadro de respuesta rápida
    updateQuickAnswerBox(number);

    // Validación específica por paso (solo si la ayuda está activa)
    if (tableState.helpVisible && tableState.currentStep === 1) {
        // Paso 1: Validar que es el número inicial correcto
        if (number === tableState.startNumber) {
            tableState.startNumberClicked = true;
            cell.classList.add('start-number');
            console.log('✅ Número inicial correcto');
        } else {
            const hint = `El número inicial debe ser el mayor de la operación: ${tableState.startNumber}`;
            showTableError('No es el número correcto. Fíjate bien y vuelve a intentarlo.', hint);
            return;
        }
    }

    // NO quitar clases - mantener TODAS las selecciones hasta ocultar ayuda
    cell.classList.add('clicked');
    cell.classList.add('selected-help');

    // Guardar celda clickeada
    if (!tableState.clickedCells.includes(number)) {
        tableState.clickedCells.push(number);
    }

    // Paso 2: Rastrear clicks en filas
    if (tableState.helpVisible && tableState.currentStep === 2) {
        const rowIndex = Math.floor((number - 1) / 10);
        if (!tableState.rowsClicked.includes(rowIndex)) {
            tableState.rowsClicked.push(rowIndex);
        }
    }
}

// ===== SISTEMA DE AYUDA =====

/**
 * Toggle help panel
 */
function toggleHelpPanel() {
    const helpPanel = document.getElementById('helpPanel');
    const toggleBtn = document.getElementById('toggleHelpBtn');
    const toggleText = document.getElementById('toggleHelpText');

    tableState.helpVisible = !tableState.helpVisible;

    if (tableState.helpVisible) {
        helpPanel.classList.remove('hidden');
        toggleBtn.classList.add('active');
        toggleText.textContent = 'OCULTAR AYUDA';

        // Ocultar caja de respuesta rápida para evitar solapamiento
        const qaBox = document.getElementById('quickAnswerBox');
        if (qaBox) qaBox.classList.add('hidden');

        // GUARDAR SELECCIÓN ACTUAL
        tableState.savedUserSelection = tableState.lastClickedNumber;

        // Al MOSTRAR ayuda, limpiar todas las selecciones para empezar de cero
        resetTableSelections();

        // Audio automático desactivado por petición del usuario
        // setTimeout(() => speakHelpStep(), 100);
    } else {
        const tempLastNumber = tableState.lastClickedNumber;

        helpPanel.classList.add('hidden');
        toggleBtn.classList.remove('active');
        toggleText.textContent = 'MOSTRAR AYUDA';

        // Mostrar caja de respuesta rápida
        const qaBox = document.getElementById('quickAnswerBox');
        if (qaBox) qaBox.classList.remove('hidden');

        // Al ocultar ayuda, resetear validaciones y limpiar selecciones de ayuda
        resetTableSelections();

        // Marcar que el alumno usó la ayuda guiada
        // Esto desactiva la validación de camino en submitQuickAnswer
        tableState.helpWasUsed = true;

        // RESTAURAR RESULTADO OBTENIDO DURANTE LA AYUDA (prioritario)
        if (tempLastNumber !== null) {
            tableState.lastClickedNumber = tempLastNumber;
            // Dejar clickedCells con solo el número final para evitar
            // que la validación de camino falle por números intermedios de la ayuda
            tableState.clickedCells = [tempLastNumber];
            let cell = document.querySelector(`#numericTable100 td[data-number="${tempLastNumber}"]`);
            if (cell) cell.classList.add('clicked');
            updateQuickAnswerBox(tempLastNumber);
        }
        // De lo contrario, intentar restaurar lo que había ANTES de la ayuda
        else if (tableState.savedUserSelection !== null) {
            tableState.lastClickedNumber = tableState.savedUserSelection;
            tableState.clickedCells = [tableState.savedUserSelection];
            let cell = document.querySelector(`#numericTable100 td[data-number="${tableState.lastClickedNumber}"]`);
            if (cell) cell.classList.add('clicked');
            updateQuickAnswerBox(tableState.lastClickedNumber);
        }

        // Resetear paso de ayuda para la próxima vez
        tableState.currentStep = 1;
    }
}

/**
 * Resetear todas las selecciones de la tabla
 */
function resetTableSelections() {
    // Resetear estado
    tableState.startNumberClicked = false;
    tableState.rowsClicked = [];
    tableState.clickedCells = [];
    tableState.lastClickedNumber = null;
    lastClickedCellForIndicators = null;

    // Quitar TODAS las clases de selección
    document.querySelectorAll('.numeric-table-100 td.start-number, .numeric-table-100 td.selected-help, .numeric-table-100 td.clicked').forEach(td => {
        td.classList.remove('start-number', 'selected-help', 'clicked');
    });

    // Eliminar TODOS los indicadores de operación
    document.querySelectorAll('.operation-indicator').forEach(indicator => {
        indicator.remove();
    });
}

/**
 * Reproducir el paso actual de ayuda mediante TTS
 */
function speakHelpStep(stepNumber) {
    if (!tableState.helpVisible) return;

    // Usar el paso actual si no se especifica uno
    const step = stepNumber || tableState.currentStep;
    const stepElement = document.querySelector(`.help-step[data-step="${step}"]`);

    if (stepElement && typeof speak === 'function') {
        const instruction = stepElement.querySelector('.step-instruction');
        if (instruction) {
            // Hablar en el idioma actual (Directamente usado por toggleAudioForAbnStep)
            speak(text, window.currentLanguage);
        }
    }
}

/**
 * Get modular parts for Spanish audio to save ElevenLabs costs
 */
function getAbnStepParts(stepNumber) {
    const lang = typeof window.currentLanguage !== 'undefined' ? window.currentLanguage : 'es-ES';
    if (lang !== 'es-ES') return null; // Modular only for Spanish currently

    const smallerNumber = Math.min(tableState.num1, tableState.num2);
    const operation = tableState.operation;
    const tens = Math.floor(smallerNumber / 10);
    const units = smallerNumber % 10;

    if (stepNumber === 1) {
        return ["Busca y haz clic en el número", tableState.startNumber.toString()];
    }

    if (stepNumber === 2) {
        const tensWord = tens === 1 ? 'decena' : 'decenas';
        const rowsWord = tens === 1 ? 'fila' : 'filas';
        const parts = [];

        if (operation === 'suma') {
            parts.push("Ahora hay que sumarle el número");
            parts.push(smallerNumber.toString());
            if (tens > 0) {
                parts.push("Fíjate que tiene");
                parts.push(tens.toString());
                parts.push(tensWord);
                if (units > 0) {
                    parts.push("y");
                    parts.push(units.toString());
                    parts.push("unidad" + (units === 1 ? '' : 'es'));
                }
                parts.push("Recuerda que sumar cada decena es igual a bajar una fila. Por tanto, debes bajar");
                parts.push(tens.toString());
                parts.push(rowsWord);
            } else if (units > 0) {
                parts.push("Solo tiene");
                parts.push(units.toString());
                parts.push("unidades"); // Generic but OK
                parts.push("por lo que no hay que bajar ninguna fila.");
            }
        } else {
            parts.push("Ahora hay que restarle el número");
            parts.push(smallerNumber.toString());
            if (tens > 0) {
                parts.push("Fíjate que tiene");
                parts.push(tens.toString());
                parts.push(tensWord);
                if (units > 0) {
                    parts.push("y");
                    parts.push(units.toString());
                    parts.push("unidad" + (units === 1 ? '' : 'es'));
                }
                parts.push("Recuerda que restar cada decena es igual a subir una fila. Por tanto, debes subir");
                parts.push(tens.toString());
                parts.push(rowsWord);
            } else if (units > 0) {
                parts.push("Solo tiene");
                parts.push(units.toString());
                parts.push("unidades");
                parts.push("por lo que no hay que subir ninguna fila.");
            }
        }
        return parts;
    }

    if (stepNumber === 3) {
        const direction = operation === 'suma' ? 'derecha' : 'izquierda';
        const verb = operation === 'suma' ? 'avanzar' : 'retroceder';
        const numbersWord = units === 1 ? 'número' : 'números';
        const parts = [];

        if (units > 0) {
            parts.push(operation === 'suma' ? "Ahora desplázate hacia la derecha, avanzar" : "Ahora desplázate hacia la izquierda, retroceder");
            parts.push(units.toString());
            parts.push(numbersWord);
            parts.push("tantos como unidades tiene el número");
            parts.push(smallerNumber.toString());
            parts.push(operation === 'suma'
                ? "Si no puedes avanzar más en esa fila, continúa por el número más a la izquierda de la fila inferior."
                : "Si no puedes retroceder más en esa fila, continúa por el número más a la derecha de la fila superior.");
        } else {
            parts.push("El número");
            parts.push(smallerNumber.toString());
            parts.push("no tiene unidades, por lo que no debes desplazarte horizontalmente. Ya estás en la posición final.");
        }
        return parts;
    }

    return null;
}

window.toggleAudioForAbnStep = function (btn, stepNumber) {
    // Si ya está reproduciendo, detener
    if (btn._abnAudioPlaying) {
        if (window.AudioManager && typeof window.AudioManager.stop === 'function') {
            window.AudioManager.stop();
        }
        btn._abnAudioPlaying = false;
        const span = btn.querySelector('span');
        if (span) span.textContent = '🔊';
        btn.classList.remove('playing');
        return;
    }

    // Obtener el texto a reproducir
    const parts = getAbnStepParts(stepNumber);
    let textToSpeak = '';

    if (parts && parts.length > 0 && tableState.startNumber > 0) {
        // Audio modular: unir las partes en una sola frase
        textToSpeak = parts.join(' ');
        console.log(`🧩 ABN audio paso ${stepNumber}:`, textToSpeak);
    } else {
        // Fallback: leer el texto del elemento HTML del paso
        const stepElement = document.querySelector(`.help-step[data-step="${stepNumber}"]`);
        if (!stepElement) {
            console.error(`❌ toggleAudioForAbnStep: no se encontró .help-step[data-step="${stepNumber}"]`);
            return;
        }
        const instruction = stepElement.querySelector('.step-instruction');
        if (!instruction) {
            console.error(`❌ toggleAudioForAbnStep: no se encontró .step-instruction en paso ${stepNumber}`);
            return;
        }
        textToSpeak = (instruction.innerText || instruction.textContent || '').trim().replace(/\s+/g, ' ');
        console.log(`🔊 ABN audio fallback paso ${stepNumber}:`, textToSpeak);
    }

    if (!textToSpeak) {
        console.warn(`⚠️ toggleAudioForAbnStep: texto vacío en paso ${stepNumber}`);
        return;
    }

    // Marcar como reproduciendo
    btn._abnAudioPlaying = true;
    btn.classList.add('playing');
    const span = btn.querySelector('span');
    if (span) span.textContent = '⏹️';

    // Reproducir con speak() directamente
    const speakFn = window.speak || (window.AudioManager && window.AudioManager.speak.bind(window.AudioManager));
    if (speakFn) {
        speakFn(textToSpeak, window.currentLanguage || 'es-ES', {
            onEnd: () => {
                btn._abnAudioPlaying = false;
                btn.classList.remove('playing');
                if (span) span.textContent = '🔊';
            }
        });
    } else {
        console.error('❌ No se encontró función speak');
        btn._abnAudioPlaying = false;
        if (span) span.textContent = '🔊';
    }
};

/**
 * Resetear panel de ayuda al paso 1
 */
function resetHelpPanel() {
    tableState.currentStep = 1;
    showHelpStep(1);
}

/**
 * Mostrar paso específico de ayuda
 */
function showHelpStep(stepNumber) {
    // Ocultar todos los pasos
    document.querySelectorAll('.help-step').forEach(step => {
        step.classList.remove('active');
        step.classList.add('hidden');
    });

    // Mostrar paso solicitado
    const stepElement = document.querySelector(`.help-step[data-step="${stepNumber}"]`);
    if (stepElement) {
        stepElement.classList.add('active');
        stepElement.classList.remove('hidden');
        tableState.currentStep = stepNumber;
        console.log(`✅ Mostrando paso ${stepNumber}`);

        // Resetear botones de audio de otros pasos para que no se queden en "stop"
        document.querySelectorAll('.audio-btn-step').forEach(btn => {
            // Usar AudioManager (que tiene resetAudioButton) en lugar de AudioService
            if (window.AudioManager && typeof window.AudioManager.resetAudioButton === 'function') {
                window.AudioManager.resetAudioButton(btn);
            } else if (window.AudioService && typeof window.AudioService.resetAudioButton === 'function') {
                window.AudioService.resetAudioButton(btn);
            } else {
                // Fallback manual: restaurar el icono del botón
                const span = btn.querySelector('span');
                if (span) span.textContent = '🔊';
                btn.classList.remove('playing', 'audio-stop-mode', 'muted-mode');
            }
        });

        // Audio automático desactivado por petición del usuario
        /*
        if (tableState.helpVisible) {
            speakHelpStep(stepNumber);
        }
        */
    } else {
        console.error(`❌ No se encontró el paso ${stepNumber}`);
    }
}

/**
 * Navegar al siguiente paso con validaciones
 */
function navigateToNextStep(fromStep) {
    const lang = typeof window.currentLanguage !== 'undefined' ? window.currentLanguage : 'es-ES';
    const isEnglish = lang.startsWith('en');

    if (fromStep === 1) {
        // Validar que se clickeó el número correcto
        if (!tableState.startNumberClicked) {
            const hint = isEnglish
                ? `Find the number ${tableState.startNumber} in the table and click on it.`
                : `Busca el número ${tableState.startNumber} en la tabla y haz clic en él.`;
            const error = isEnglish
                ? 'First you must click on the correct number in the table.'
                : 'Primero debes hacer clic en el número correcto de la tabla.';

            showTableError(error, hint);
            return;
        }
        showHelpStep(2);
    } else if (fromStep === 2) {
        // Validar que se clickearon las filas necesarias
        const smallerNumber = Math.min(tableState.num1, tableState.num2);
        const tensNeeded = Math.floor(smallerNumber / 10);

        if (tensNeeded > 0 && tableState.rowsClicked.length < tensNeeded) {
            const movement = tableState.operation === 'suma'
                ? (isEnglish ? 'down' : 'bajar')
                : (isEnglish ? 'up' : 'subir');

            const rowsWord = isEnglish
                ? (tensNeeded === 1 ? 'row' : 'rows')
                : (tensNeeded === 1 ? 'fila' : 'filas');

            const hint = isEnglish
                ? `You must go ${movement} ${tensNeeded} ${rowsWord} from the starting number.`
                : `Debes ${tableState.operation === 'suma' ? 'bajar' : 'subir'} ${tensNeeded} ${rowsWord} desde el número inicial.`;

            const error = isEnglish
                ? `You must click on ${tensNeeded} ${rowsWord}. Try again.`
                : `Debes hacer clic en ${tensNeeded} ${rowsWord}. Vuelve a intentarlo.`;

            showTableError(error, hint);
            return;
        }
        showHelpStep(3);
    } else if (fromStep === 3) {
        // Step 3 is now the final step - just hide the help panel
        // Use toggleHelpPanel to ensure restoration logic runs!

        // Ensure we end on step 1 for next time
        tableState.currentStep = 1;

        // Simular clic en botón cerrar para ejecutar toda la lógica de limpieza y restauración
        toggleHelpPanel();
    }
}

/**
 * Navegar al paso anterior
 */
function navigateToPreviousStep(toStep) {
    showHelpStep(toStep);
}

/**
 * Actualizar contenido de ayuda según la operación
 */
function updateHelpContent() {
    const smallerNumber = Math.min(tableState.num1, tableState.num2);

    // Paso 1: Mostrar número inicial
    document.getElementById('startNumberDisplay').textContent = tableState.startNumber;

    // Paso 2: Generar texto de descomposición con colores
    const decompositionHTML = generateDecompositionHTML(smallerNumber, tableState.operation);
    document.getElementById('decompositionText').innerHTML = decompositionHTML;

    // Paso 3: Instrucción para unidades
    const unitsInstructionHTML = generateUnitsInstructionHTML(smallerNumber, tableState.operation);
    document.getElementById('pathInstructionText').innerHTML = unitsInstructionHTML;

    // Paso 4: NO mostrar número objetivo (no revelar solución)
}

/**
 * Colorear un número (decenas en rojo, unidades en azul)
 */
function colorCodeNumber(number) {
    const numStr = number.toString();

    if (numStr.length === 1) {
        // Solo unidad (azul)
        return `<span style="color: #1e40af; font-weight: 800;">${numStr}</span>`;
    } else {
        // Dividir en decenas y unidades
        const tens = numStr.substring(0, numStr.length - 1);
        const unit = numStr.substring(numStr.length - 1);
        return `<span style="color: #991b1b; font-weight: 800;">${tens}</span><span style="color: #1e40af; font-weight: 800;">${unit}</span>`;
    }
}

/**
 * Generar HTML de paso 2 (descomposición con colores) - SOLO DECENAS
 */
/**
 * Generar HTML de paso 2 (descomposición con colores) - SOLO DECENAS
 */
function generateDecompositionHTML(number, operation) {
    const lang = typeof window.currentLanguage !== 'undefined' ? window.currentLanguage : 'es-ES';
    const isEnglish = lang.startsWith('en');

    const tens = Math.floor(number / 10);
    const units = number % 10;

    // Número coloreado
    const numberColored = colorCodeNumber(number);

    let html = '';

    if (isEnglish) {
        // ENGLISH
        const tensWord = tens === 1 ? 'ten' : 'tens';
        const unitWord = units === 1 ? 'unit' : 'units';
        const rowsWord = tens === 1 ? 'row' : 'rows';

        if (operation === 'suma') {
            html = `Now add the number ${numberColored}.`;
            if (tens > 0) {
                html += ` Notice it has <span style="color: #991b1b; font-weight: 800;">${tens}</span> ${tensWord}`;
                if (units > 0) {
                    html += ` and <span style="color: #1e40af; font-weight: 800;">${units}</span> ${unitWord}`;
                }
                html += `.<br><br>Remember that adding each ten equals going down one row.<br><br>`;
                html += `So, you must go down <span style="color: #991b1b; font-weight: 800;">${tens}</span> ${rowsWord}.`;
            } else if (units > 0) {
                html += ` It only has <span style="color: #1e40af; font-weight: 800;">${units}</span> ${unitWord}, so you don't need to go down any rows.`;
            }
        } else {
            // SUBTRACTION
            html = `Now subtract the number ${numberColored}.`;
            if (tens > 0) {
                html += ` Notice it has <span style="color: #991b1b; font-weight: 800;">${tens}</span> ${tensWord}`;
                if (units > 0) {
                    html += ` and <span style="color: #1e40af; font-weight: 800;">${units}</span> ${unitWord}`;
                }
                html += `.<br><br>Remember that subtracting each ten equals going up one row.<br><br>`;
                html += `So, you must go up <span style="color: #991b1b; font-weight: 800;">${tens}</span> ${rowsWord}.`;
            } else if (units > 0) {
                html += ` It only has <span style="color: #1e40af; font-weight: 800;">${units}</span> ${unitWord}, so you don't need to go up any rows.`;
            }
        }
    } else {
        // SPANISH (Original logic)
        const tensWord = tens === 1 ? 'decena' : 'decenas';
        const rowsWord = tens === 1 ? 'fila' : 'filas';

        if (operation === 'suma') {
            html = `Ahora hay que sumarle el número ${numberColored}.`;
            if (tens > 0) {
                html += ` Fíjate que tiene <span style="color: #991b1b; font-weight: 800;">${tens}</span> ${tensWord}`;
                if (units > 0) {
                    html += ` y <span style="color: #1e40af; font-weight: 800;">${units}</span> unidad${units === 1 ? '' : 'es'}`;
                }
                html += `.<br><br>Recuerda que sumar cada decena es igual a bajar una fila.<br><br>`;
                html += `Por tanto, debes bajar <span style="color: #991b1b; font-weight: 800;">${tens}</span> ${rowsWord}.`;
            } else if (units > 0) {
                html += ` Solo tiene <span style="color: #1e40af; font-weight: 800;">${units}</span> unidad${units === 1 ? '' : 'es'}, por lo que no hay que bajar ninguna fila.`;
            }
        } else {
            html = `Ahora hay que restarle el número ${numberColored}.`;
            if (tens > 0) {
                html += ` Fíjate que tiene <span style="color: #991b1b; font-weight: 800;">${tens}</span> ${tensWord}`;
                if (units > 0) {
                    html += ` y <span style="color: #1e40af; font-weight: 800;">${units}</span> unidad${units === 1 ? '' : 'es'}`;
                }
                html += `.<br><br>Recuerda que restar cada decena es igual a subir una fila.<br><br>`;
                html += `Por tanto, debes subir <span style="color: #991b1b; font-weight: 800;">${tens}</span> ${rowsWord}.`;
            } else if (units > 0) {
                html += ` Solo tiene <span style="color: #1e40af; font-weight: 800;">${units}</span> unidad${units === 1 ? '' : 'es'}, por lo que no hay que subir ninguna fila.`;
            }
        }
    }

    return html;
}

/**
 * Generar HTML de paso 3 (instrucción de unidades) - MOVIMIENTO HORIZONTAL
 */
/**
 * Generar HTML de paso 3 (instrucción de unidades) - MOVIMIENTO HORIZONTAL
 */
function generateUnitsInstructionHTML(number, operation) {
    const lang = typeof window.currentLanguage !== 'undefined' ? window.currentLanguage : 'es-ES';
    const isEnglish = lang.startsWith('en');

    const units = number % 10;

    // Número coloreado
    const numberColored = colorCodeNumber(number);

    let html = '';

    if (isEnglish) {
        const direction = operation === 'suma' ? 'right' : 'left';
        const verb = operation === 'suma' ? 'move forward' : 'move back';
        const numbersWord = units === 1 ? 'number' : 'numbers';

        if (units > 0) {
            html = `Now move to the ${direction}, ${verb} <span style="color: #1e40af; font-weight: 800;">${units}</span> ${numbersWord}, as many as units the number ${numberColored} has.`;

            if (operation === 'suma') {
                html += ` If you can't move forward more in that row, continue from the leftmost number of the row below.`;
            } else {
                html += ` If you can't move back more in that row, continue from the rightmost number of the row above.`;
            }
        } else {
            html = `The number ${numberColored} has no units, so you don't use to move horizontally. You are already at the final position.`;
        }

    } else {
        const direction = operation === 'suma' ? 'derecha' : 'izquierda';
        const verb = operation === 'suma' ? 'avanzar' : 'retroceder';
        const numbersWord = units === 1 ? 'número' : 'números';

        if (units > 0) {
            html = `Ahora desplázate hacia la ${direction}, ${verb} <span style="color: #1e40af; font-weight: 800;">${units}</span> ${numbersWord}, tantos como unidades tiene el número ${numberColored}.`;

            if (operation === 'suma') {
                html += ` Si no puedes avanzar más en esa fila, continúa por el número más a la izquierda de la fila inferior.`;
            } else {
                html += ` Si no puedes retroceder más en esa fila, continúa por el número más a la derecha de la fila superior.`;
            }
        } else {
            html = `El número ${numberColored} no tiene unidades, por lo que no debes desplazarte horizontalmente. Ya estás en la posición final.`;
        }
    }

    return html;
}

/**
 * Actualizar display de operación en header
 */
function updateOperationDisplay() {
    const display = document.getElementById('tableOperationDisplay');
    const operator = tableState.operation === 'suma' ? '+' : '-';

    // SIEMPRE mostrar el número mayor primero
    const num1 = tableState.startNumber; // El mayor
    const num2 = Math.min(tableState.num1, tableState.num2); // El menor

    // Colorear ambos números
    const num1Colored = colorCodeNumber(num1);
    const num2Colored = colorCodeNumber(num2);

    display.innerHTML = `${num1Colored} ${operator} ${num2Colored}`;
}

// ===== EVENT LISTENERS =====

document.addEventListener('DOMContentLoaded', function () {
    // Botón volver a Step 5
    const backBtn = document.getElementById('backToStep5Btn');
    if (backBtn) {
        backBtn.addEventListener('click', () => closeNumericTableScreen(false));
    }

    // Botón RESET (Comenzar de nuevo)
    const resetBtn = document.getElementById('resetTableBtn');
    if (resetBtn) {
        resetBtn.addEventListener('click', () => {
            tableState.savedUserSelection = null; // Clear saved state on manual reset
            resetTableSelections();
            resetQuickAnswerBox();
            if (typeof speak === 'function') speak("Tabla reiniciada", window.currentLanguage);
        });
    }

    // Botón toggle ayuda
    const toggleHelpBtn = document.getElementById('toggleHelpBtn');
    if (toggleHelpBtn) {
        toggleHelpBtn.addEventListener('click', toggleHelpPanel);
    }

    // Botones de navegación de pasos
    document.querySelectorAll('.btn-step-next').forEach(btn => {
        btn.addEventListener('click', function () {
            const fromStep = parseInt(this.dataset.fromStep);
            navigateToNextStep(fromStep);
        });
    });

    document.querySelectorAll('.btn-step-back').forEach(btn => {
        btn.addEventListener('click', function () {
            const toStep = parseInt(this.dataset.toStep);
            navigateToPreviousStep(toStep);
        });
    });

    // 🔊 AUDIO EN BOTONES PRINCIPALES (solo botones con texto largo/descriptivo)
    // NO se aplica a botones de una sola palabra
    setupButtonAudio('backToStep5Btn');
    setupButtonAudio('resetTableBtn');
    // toggleHelpBtn, submitQuickAnswerBtn, btn-step-next y btn-step-back
    // NO tienen audio al hacer clic (son palabras simples)
});

/**
 * Configura el audio para un botón: habla al hacer click y al mantener el ratón 1 segundo
 */
function setupButtonAudio(btnOrId) {
    const btn = typeof btnOrId === 'string' ? document.getElementById(btnOrId) : btnOrId;
    if (!btn) return;

    let hoverTimer = null;

    const speakButtonText = () => {
        if (typeof speak === 'function') {
            // Limpiamos emojis, flechas y símbolos para que el TTS lea solo el texto
            let text = btn.innerText || btn.textContent;
            // 🔄, ←, ✕, ➕, ➖, 💡, 📊, ✓
            text = text.replace(/[🔄←✕➕➖💡📊✓🧮]/gu, '').trim();
            if (text) speak(text, window.currentLanguage);
        }
    };

    // Al hacer click
    btn.addEventListener('click', () => {
        // Cancelar timer de hover para evitar doble audio si se pulsa pronto
        if (hoverTimer) clearTimeout(hoverTimer);
        speakButtonText();
    });

    // Al mantener el ratón 1 segundo
    btn.addEventListener('mouseenter', () => {
        hoverTimer = setTimeout(() => {
            speakButtonText();
        }, 1000);
    });

    // Si se quita el ratón antes del segundo, cancelar
    btn.addEventListener('mouseleave', () => {
        if (hoverTimer) {
            clearTimeout(hoverTimer);
            hoverTimer = null;
        }
    });
}

// Modificar el botón "Resuelve con la tabla numérica" para abrir la nueva pantalla
function openAbnHelper() {
    // Obtener datos del cálculo actual
    const num1 = parseInt(document.getElementById('calcNum1').textContent);
    const num2 = parseInt(document.getElementById('calcNum2').textContent);
    const operator = document.getElementById('calcOperator').textContent;
    const operation = operator === '+' ? 'suma' : 'resta';

    // Abrir pantalla de tabla numérica
    openNumericTableScreen(num1, num2, operation);

    // Resetear el recuadro de respuesta rápida
    resetQuickAnswerBox();
}

// ===== RESPUESTA RÁPIDA =====

/**
 * Resetear recuadro de respuesta rápida
 */
function resetQuickAnswerBox() {
    const quickAnswerNumber = document.getElementById('quickAnswerNumber');
    const submitBtn = document.getElementById('submitQuickAnswerBtn');
    const errorBubble = document.getElementById('answerErrorBubble');

    if (quickAnswerNumber) {
        quickAnswerNumber.textContent = '-';
    }

    if (submitBtn) {
        submitBtn.disabled = true;
    }

    if (errorBubble) {
        errorBubble.classList.add('hidden');
    }
}

/**
 * Actualizar recuadro de respuesta rápida cuando se hace clic en un número
 */
function updateQuickAnswerBox(number) {
    const quickAnswerNumber = document.getElementById('quickAnswerNumber');
    const submitBtn = document.getElementById('submitQuickAnswerBtn');

    if (quickAnswerNumber) {
        quickAnswerNumber.textContent = number;
    }

    if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('hidden');
    }

    // Ocultar error si estaba visible
    closeAnswerError();
}

/**
 * Enviar respuesta rápida
 */
function submitQuickAnswer() {
    const lastNumber = tableState.lastClickedNumber;

    if (lastNumber === tableState.targetNumber) {
        // VALIDACIÓN DE CAMINO (PATH)
        // Solo se valida si el alumno NO usó la ayuda guiada.
        // Si usó la ayuda, confiamos en que llegó al número correcto siguiendo los pasos.
        if (!tableState.helpWasUsed) {
            const totalToAdjust = tableState.operation === 'suma' ?
                Math.min(tableState.num1, tableState.num2) : tableState.num2;

            let totalMovement = 0;
            let validPath = true;
            const path = tableState.clickedCells;

            // 1. Debe empezar en el número inicial
            if (path[0] !== tableState.startNumber) validPath = false;

            // 2. Cada paso debe ser de 1 o 10
            for (let i = 1; i < path.length; i++) {
                const diff = Math.abs(path[i] - path[i - 1]);
                if (diff !== 1 && diff !== 10) validPath = false;
                totalMovement += diff;
            }

            // 3. El movimiento total debe coincidir con el número que sumamos/restamos
            if (!validPath || totalMovement !== totalToAdjust) {
                const msg = "Inténtalo otra vez. El resultado es correcto, pero has pulsado números que no deberías. Pulsa de nuevo en ellos para quitarlos antes de volver a enviar.";
                if (typeof speak === 'function') {
                    speak(msg, window.currentLanguage);
                }
                showTableError("Camino incorrecto", "Has seleccionado números que no forman parte de la operación. Pulsa sobre los extras para quitarlos.");
                return;
            }
        }

        // ABN HELPER FIX: Use centralized handler
        console.log('✅ ABN Helper: Delegating to handleNumberSelection:', lastNumber);

        // Close table first
        closeNumericTableScreen(false);

        // Advance to Step 6 via centralized logic
        if (typeof window.handleNumberSelection === 'function') {
            window.handleNumberSelection(lastNumber);
        } else {
            console.error("Critical: window.handleNumberSelection missing. Forcing specific Step 6 advance.");
            if (window.wizardState) window.wizardState.data.calculation = lastNumber;
            window.markStepComplete(5);
            setTimeout(() => window.goToWizardStep(6), 1000);
        }
        return; // Stop execution here

    } else {
        // Respuesta incorrecta - Audio y abrir ayuda automáticamente
        if (typeof speak === 'function') {
            speak("Inténtalo otra vez. Sigue los pasos de la ayuda", window.currentLanguage);
        }

        // Abrir la ayuda si no está abierta
        if (!tableState.helpVisible) {
            // Un pequeño delay para que el audio anterior empiece bien
            setTimeout(() => {
                if (!tableState.helpVisible) {
                    toggleHelpPanel();
                }
            }, 500);
        }

        // Limpiar todas las selecciones visuales de la tabla para que el alumno pueda comenzar de nuevo
        document.querySelectorAll('.numeric-table-100 td.start-number, .numeric-table-100 td.selected-help, .numeric-table-100 td.clicked').forEach(td => {
            td.classList.remove('start-number', 'selected-help', 'clicked');
        });

        // Resetear validaciones de los pasos de ayuda
        tableState.startNumberClicked = false;
        tableState.rowsClicked = [];
        tableState.clickedCells = [];

        console.log('❌ Respuesta incorrecta - Se activa ayuda automática');
    }
}

/**
 * Mostrar globo de error para respuesta incorrecta (ya no se usa, la lógica se movió a submitQuickAnswer)
 */
function showAnswerError() {
    tableState.clickedCells = [];
}

/**
 * Cerrar globo de error
 */
function closeAnswerError() {
    const errorBubble = document.getElementById('answerErrorBubble');
    if (errorBubble) {
        errorBubble.classList.add('hidden');
    }
}

// Exportar funciones globales
if (typeof window !== 'undefined') {
    window.submitQuickAnswer = submitQuickAnswer;
    window.closeAnswerError = closeAnswerError;
    window.openAbnHelper = openAbnHelper;
}

/**
 * Variables para rastrear último número clickeado (para detectar movimientos)
 */
let lastClickedCellForIndicators = null;

/**
 * Mostrar indicador de operación entre dos celdas
 * MEJORADO: Ahora maneja cambios de fila al sumar/restar unidades
 */
function showOperationIndicator(previousNumber, currentNumber, previousCell, currentCell) {
    if (!previousNumber || !currentNumber || !previousCell || !currentCell) return;

    const rowPrev = Math.floor((previousNumber - 1) / 10);
    const colPrev = (previousNumber - 1) % 10;
    const rowCurr = Math.floor((currentNumber - 1) / 10);
    const colCurr = (currentNumber - 1) % 10;

    const rowDiff = rowCurr - rowPrev;
    const colDiff = colCurr - colPrev;
    const numberDiff = currentNumber - previousNumber;

    // SUMA: Bajar fila exactamente (+10) - Mostrar a la izquierda
    if (tableState.operation === 'suma' && rowDiff === 1 && colDiff === 0) {
        createIndicator(currentCell, '+10', 'indicator-tens indicator-left');
    }
    // SUMA: Avanzar a la derecha (+1) - misma fila
    else if (tableState.operation === 'suma' && numberDiff === 1 && rowDiff === 0) {
        createIndicator(currentCell, '+1', 'indicator-units indicator-top');
    }
    // SUMA: Avanzar (+1) con cambio de fila (ej: 10 → 11, 20 → 21)
    else if (tableState.operation === 'suma' && numberDiff === 1 && rowDiff === 1) {
        createIndicator(currentCell, '+1', 'indicator-units indicator-top');
    }
    // RESTA: Subir fila exactamente (-10) - Mostrar a la derecha
    else if (tableState.operation === 'resta' && rowDiff === -1 && colDiff === 0) {
        createIndicator(currentCell, '-10', 'indicator-tens indicator-right');
    }
    // RESTA: Retroceder a la izquierda (-1) - misma fila
    else if (tableState.operation === 'resta' && numberDiff === -1 && rowDiff === 0) {
        createIndicator(currentCell, '-1', 'indicator-units indicator-top');
    }
    // RESTA: Retroceder (-1) con cambio de fila (ej: 11 → 10, 21 → 20)
    else if (tableState.operation === 'resta' && numberDiff === -1 && rowDiff === -1) {
        createIndicator(currentCell, '-1', 'indicator-units indicator-top');
    }
}

/**
 * Crear un indicador visual en una celda
 */
function createIndicator(cell, text, className) {
    if (!cell) return;

    // Buscar si ya existe un indicador del mismo tipo en esta celda
    const existingIndicator = cell.querySelector(`.${className.split(' ').join('.')}`);

    if (existingIndicator) {
        // Actualizar texto del indicador existente
        existingIndicator.textContent = text;
    } else {
        // Crear nuevo indicador
        const indicator = document.createElement('div');
        indicator.className = `operation-indicator ${className}`;
        indicator.textContent = text;
        cell.appendChild(indicator);
    }
}

